var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 120 120",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m86 96c3.3137 0 6-2.6863 6-6v-44c0-3.3137-2.6863-6-6-6h-35-35c-3.3137 0-6 2.6863-6 6v44c0 3.3137 2.6863 6 6 6z",
    fill: "#027ef1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17 76c0-1.1046.8954-2 2-2h29c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-29c-1.1046 0-2-.8954-2-2z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33 69c1.1046 0 2-.8954 2-2v-8c0-1.1046-.8954-2-2-2h-6.5-6.5c-1.1046 0-2 .8954-2 2v8c0 1.1046.8954 2 2 2z",
    fill: "#ffba33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m58 45c0 14.3594 11.6406 26 26 26s26-11.6406 26-26-11.6406-26-26-26-26 11.6406-26 26z",
    fill: "#ce3b3b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m78.4142 36.5858c-.781-.7811-2.0474-.7811-2.8284 0-.7811.781-.7811 2.0474 0 2.8284l5.5858 5.5858-5.5858 5.5858c-.7811.781-.7811 2.0474 0 2.8284.781.7811 2.0474.7811 2.8284 0l5.5858-5.5858 5.5858 5.5858c.781.781 2.0474.781 2.8284 0 .781-.7811.781-2.0474 0-2.8284l-5.5858-5.5858 5.5858-5.5858c.781-.781.781-2.0473 0-2.8284-.781-.781-2.0474-.781-2.8284 0l-5.5858 5.5858z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaid);
export default __webpack_public_path__ + "static/media/unpaid.4a5cbf9a4f6b3ea08f337f2e92b1b386.svg";
export { ForwardRef as ReactComponent };